import { Instance, SnapshotIn, types } from "mobx-state-tree";

export const SurveyRuleQuestionCodeKeyOptionModel = types.model(
  "SurveyRuleQuestionCodeKeyOptionModel",
  {
    type: types.literal("QUESTION_CODE"),
    questionCodes: types.array(types.string),
  },
);

export const SurveyRuleRespondentColumnNameKeyOptionModel = types.model(
  "SurveyRuleRespondentColumnNameKeyOptionModel",
  {
    type: types.literal("RESPONDENT_COLUMN_NAME"),
    respondentColumnNames: types.array(types.string),
  },
);

export const SurveyRuleKeyOptionModel = types.union(
  SurveyRuleQuestionCodeKeyOptionModel,
  SurveyRuleRespondentColumnNameKeyOptionModel,
);

export const createSurveyRuleKeyOptionModel = (
  surveyRuleKeyOption: SnapshotIn<typeof SurveyRuleKeyOptionModel>,
): Instance<typeof SurveyRuleKeyOptionModel> =>
  SurveyRuleKeyOptionModel.create(surveyRuleKeyOption);
